import styled from 'styled-components'

type Props = {
  color?: string
}

function Round({ color = '#838685' }: Props) {
  return <Wrapper color={color} />
}

export default Round

const Wrapper = styled.div<{ color: string }>`
  width: 12px;
  height: 13px;
  background-color: ${({ color }) => color};
  border-radius: 9999px;
`
